import { render, staticRenderFns } from "./DialogReportSzvn.vue?vue&type=template&id=0a6e6d12&scoped=true&"
import script from "./DialogReportSzvn.vue?vue&type=script&lang=js&"
export * from "./DialogReportSzvn.vue?vue&type=script&lang=js&"
import style0 from "./DialogReportSzvn.vue?vue&type=style&index=0&id=0a6e6d12&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6e6d12",
  null
  
)

export default component.exports